export type SentryEventCreationFlow = 'create_event' | 'edit_event';

export type SentryEventCreationStep =
	| 'event_start'
	| 'event_bootstrap'
	| 'event_what'
	| 'event_when'
	| 'event_where'
	| 'event_how_much'
	| 'event_publish';

export type SentryEventCreationState = {
	flow: SentryEventCreationFlow;
	step: SentryEventCreationStep;
};

let eventCreationState: SentryEventCreationState | null = null;

export const getSentryEventCreationState = () => eventCreationState;

export const setSentryEventCreationState = (
	nextState: SentryEventCreationState
) => {
	eventCreationState = nextState;
};

export const resetSentryEventCreationState = () => {
	eventCreationState = null;
};

export const getSentryEventCreationStep = (
	pathname: string
): SentryEventCreationStep => {
	if (pathname === '/me/events/start') return 'event_start';
	if (pathname.includes('/new')) return 'event_bootstrap';
	if (pathname.endsWith('/when')) return 'event_when';
	if (pathname.endsWith('/where')) return 'event_where';
	if (pathname.endsWith('/how-much')) return 'event_how_much';
	return 'event_what';
};
